import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

export class IconFormControl extends React.Component {
  static propTypes = {
    icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
    type: PropTypes.string
  };

  static defaultProps = {
    icon: faSearch,
    type: 'text'
  };

  render() {
    const { icon, ...props } = this.props;
    return (
      <div className="search-container">
        <FormGroup>
          <div className="icon">
            <FontAwesomeIcon icon={icon} />
          </div>
          <FormControl {...props} />
        </FormGroup>
      </div>
    );
  }
}

export default IconFormControl;
